import {
  DashboardOutlined,
  FileTextOutlined,
  PlusCircleOutlined,
  UserOutlined,
  TeamOutlined,
  BookOutlined,
  CalendarOutlined,
  BarChartOutlined,
  LineChartOutlined,
  PieChartOutlined,
  SettingOutlined,
  HomeOutlined,
  ContainerOutlined,
  AppstoreAddOutlined,
  FolderOpenOutlined,
  IdcardOutlined,
  SolutionOutlined,
  FileSearchOutlined,
  BankOutlined,
  MinusCircleOutlined,
  BellOutlined,
  TrophyOutlined,
  CarOutlined,
  DollarOutlined,
  LayoutOutlined,
} from '@ant-design/icons';

export const menuItems = [
  {
    key: 'dashboard',
    label: 'Dashboard',
    icon: <DashboardOutlined />,
    path: '/dashboard',
  },
  {
    key: 'student_management',
    label: 'Student Management',
    icon: <UserOutlined />,
    children: [
      {
        key: 'add-student',
        label: 'Add Student',
        icon: <AppstoreAddOutlined />,
        path: '/student_crud',
      },
      {
        key: 'student-list',
        label: 'Student List',
        icon: <FileSearchOutlined />,
        path: '/student_list',
      },
      {
        key: 'student-registration',
        label: 'Student Registration',
        icon: <IdcardOutlined />,
        path: '/student_registration',
      },
    ],
  },
  {
    key: 'teacher_management',
    label: 'Teacher Management',
    icon: <TeamOutlined />,
    children: [
      {
        key: 'add-teacher',
        label: 'Add Teacher',
        icon: <AppstoreAddOutlined />,
        path: '/teacher_crud',
      },
      {
        key: 'teacher-list',
        label: 'Teacher List',
        icon: <FileSearchOutlined />,
        path: '/teacher_list',
      },
      {
        key: 'staff-directory',
        label: 'Staff Directory',
        icon: <SolutionOutlined />,
        path: '/staff_directory',
      },
    ],
  },
  {
    key: 'academic_management',
    label: 'Academic Management',
    icon: <BookOutlined />,
    children: [
      {
        key: 'classes',
        label: 'Classes',
        icon: <ContainerOutlined />,
        path: '/class_crud',
      },
      {
        key: 'subjects',
        label: 'Subjects',
        icon: <FolderOpenOutlined />,
        path: '/subject_crud',
      },
      {
        key: 'timetable',
        label: 'Timetable',
        icon: <CalendarOutlined />,
        path: '/timetable',
      },
      {
        key: 'curriculum',
        label: 'Curriculum',
        icon: <FileTextOutlined />,
        path: '/curriculum',
      },
    ],
  },
  {
    key: 'attendance',
    label: 'Attendance',
    icon: <CalendarOutlined />,
    children: [
      {
        key: 'daily-attendance',
        label: 'Daily Attendance',
        icon: <PlusCircleOutlined />,
        path: '/daily_attendance',
      },
      {
        key: 'attendance-reports',
        label: 'Attendance Reports',
        icon: <BarChartOutlined />,
        path: '/attendance_reports',
      },
      {
        key: 'leave-management',
        label: 'Leave Management',
        icon: <MinusCircleOutlined />,
        path: '/leave_management',
      },
    ],
  },
  {
    key: 'exams',
    label: 'Exams & Results',
    icon: <FileTextOutlined />,
    children: [
      {
        key: 'exam-schedule',
        label: 'Exam Schedule',
        icon: <CalendarOutlined />,
        path: '/exam_schedule',
      },
      {
        key: 'grade-book',
        label: 'Grade Book',
        icon: <BarChartOutlined />,
        path: '/grade_book',
      },
      {
        key: 'results',
        label: 'Results',
        icon: <PieChartOutlined />,
        path: '/results',
      },
    ],
  },
  {
    key: 'communication',
    label: 'Communication',
    icon: <BellOutlined />,
    children: [
      {
        key: 'announcements',
        label: 'Announcements',
        icon: <FileTextOutlined />,
        path: '/announcements',
      },
      {
        key: 'messages',
        label: 'Messages',
        icon: <BellOutlined />,
        path: '/messages',
      },
      {
        key: 'newsletters',
        label: 'Newsletters',
        icon: <FileTextOutlined />,
        path: '/newsletters',
      },
    ],
  },
  {
    key: 'activities',
    label: 'Activities & Events',
    icon: <TrophyOutlined />,
    children: [
      {
        key: 'events',
        label: 'Events',
        icon: <CalendarOutlined />,
        path: '/events',
      },
      {
        key: 'sports',
        label: 'Sports',
        icon: <TrophyOutlined />,
        path: '/sports',
      },
      {
        key: 'clubs',
        label: 'Clubs',
        icon: <TeamOutlined />,
        path: '/clubs',
      },
    ],
  },

  {
    key: 'transport',
    label: 'Transportation',
    icon: <CarOutlined />,
    children: [
      {
        key: 'routes',
        label: 'Routes',
        icon: <ContainerOutlined />,
        path: '/routes',
      },
      {
        key: 'transport-students',
        label: 'Transport Students',
        icon: <UserOutlined />,
        path: '/transport_students',
      },
      {
        key: 'transport-fees',
        label: 'Transport Fees',
        icon: <DollarOutlined />,
        path: '/transport_fees',
      },
    ],
  },
  {
    key: 'finance',
    label: 'Finance',
    icon: <DollarOutlined />,
    children: [
      {
        key: 'fee-management',
        label: 'Fee Management',
        icon: <DollarOutlined />,
        path: '/fee_management',
      },
      {
        key: 'expenses',
        label: 'Expenses',
        icon: <PieChartOutlined />,
        path: '/expenses',
      },
      {
        key: 'financial-reports',
        label: 'Financial Reports',
        icon: <BarChartOutlined />,
        path: '/financial_reports',
      },
    ],
  },
  {
    key: 'reports',
    label: 'Reports',
    icon: <BarChartOutlined />,
    children: [
      {
        key: 'academic-reports',
        label: 'Academic Reports',
        icon: <LineChartOutlined />,
        path: '/reports/academic',
      },
      {
        key: 'attendance-reports',
        label: 'Attendance Reports',
        icon: <PieChartOutlined />,
        path: '/reports/attendance',
      },
      {
        key: 'financial-reports',
        label: 'Financial Reports',
        icon: <BarChartOutlined />,
        path: '/reports/financial',
      },
    ],
  },
  {
    key: 'settings',
    label: 'Settings',
    icon: <SettingOutlined />,
    children: [
      {
        key: 'school-info',
        label: 'School Information',
        icon: <BankOutlined />,
        path: '/school_info',
      },
      {
        key: 'users',
        label: 'Users',
        icon: <UserOutlined />,
        path: '/users',
      },
      {
        key: 'roles',
        label: 'Roles & Permissions',
        icon: <SettingOutlined />,
        path: '/roles',
      },
    ],
  },
  {
    key: 'cms_blocks',
    label: 'CMS Blocks (Admin Only)',
    icon: <LayoutOutlined />,
    children: [
      {
        key: 'block-demo',
        label: 'Block Demo',
        icon: <LayoutOutlined />,
        path: '/cms/blocks',
      },
      {
        key: 'block-display',
        label: 'Block Display',
        icon: <LayoutOutlined />,
        path: '/cms/blocks/display',
      },
      {
        key: 'block-manage',
        label: 'Block Management',
        icon: <LayoutOutlined />,
        path: '/cms/blocks/manage',
      },
    ],
  },
];
